import { render, staticRenderFns } from "./OrmItemComments.vue?vue&type=template&id=3ffa4293&scoped=true"
import script from "./OrmItemComments.vue?vue&type=script&lang=js"
export * from "./OrmItemComments.vue?vue&type=script&lang=js"
import style0 from "./OrmItemComments.vue?vue&type=style&index=0&id=3ffa4293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa4293",
  null
  
)

export default component.exports